// Mensajes para el usuario final —
// independientes del texto que manda el backend (ese es `description`, pensado para
// logs/debug, no para mostrar). Estructura plana por ahora; si el proyecto se vuelve
// multi-idioma, cada valor pasa a ser un objeto {es: '...', en: '...'} sin romper a los
// consumidores de getErrorMessage().
export const ERROR_MESSAGES = {
    1002: 'Tu sesión expiró. Inicia sesión de nuevo.',
    1003: 'No tienes permiso para hacer esto.',
    1004: 'No se encontró lo que buscabas.',
    // 2002 es a propósito el mismo mensaje para "nick no existe" y "contraseña incorrecta" --
    // distinguirlos es enumeración de usuarios (ver errorCatalog.js, bloque 2000-2999).
    2002: 'Credenciales inválidas.',
    2003: 'Tu cuenta ha sido archivada. No tienes acceso al sistema.',
    2004: 'Cuenta suspendida por falta de pago.',
    3004: 'Solo quien creó esta tarea o un administrador pueden eliminarla.',
    // 3005 lleva `space_name` dinámico en `error.body` -- este mensaje genérico es el
    // fallback para consumidores que no lo arman a mano (ver ComponentTaskHoy.jsx, modo
    // standalone, que sí usa `error.body.space_name` para el mensaje con nombre real).
    3005: 'No perteneces al espacio de esta tarea.',
    // cuadros de trabajo / workframe (integración main→dev, epic D1)
    3101: 'Cuadro de trabajo no encontrado.',
    3102: 'No perteneces al espacio de este cuadro de trabajo.',
    3103: 'El nombre del cuadro de trabajo es requerido.',
    // 4001 (contribuciones)
    // y 8001/21001 (subir grabación/archivo) no tienen entrada acá a propósito: sin
    // consumidor real de frontend hoy (4001 no se llama desde ningún componente; 8001/21001
    // solo se loguean con `console.error`, nunca se muestran al usuario) — agregar el
    // mensaje cuando exista un consumidor real que lo necesite.
    4002: 'No se pudo actualizar tu perfil. Intenta de nuevo.',
    4008: 'La contraseña actual no es correcta.',
    4009: 'Ese nick ya está en uso.',
    4010: 'Ese enlace de recuperación no es válido, ya se usó, o expiró. Solicita uno nuevo.',
    // docs — historial de versiones (integración main→dev, epic D2). 5001/5002/5003 no tienen
    // entrada: son 404 que el panel de historial ya traduce a "esa versión ya no existe" en su
    // propio contexto; agregar acá si aparece un consumidor genérico.
    5004: 'No tienes permiso para ver el historial de versiones de este documento.',
    5005: 'No tienes permiso para crear una versión de este documento.',
    5006: 'Solo quien creó el documento o un administrador del espacio pueden restaurar versiones.',
    7001: 'Tu comentario quedó vacío después de quitar contenido no permitido. Revísalo e intenta de nuevo.',
    10001: 'No se pudo colocar la decoración. Intenta de nuevo.',
    10002: 'No se pudo actualizar la decoración. Intenta de nuevo.',
    // 22011 es frontend-only -- `backend/src/shared/errorCatalog.js` usa 22001-22010 para sus
    // propios errores de WebRTC (AppError con httpStatus); este es un fallo de `import()`
    // dinámico en el navegador, nunca toca el servidor. Numerado en 22011 (siguiente libre en
    // el rango 22000-22999/webrtc) por cercanía temática con los códigos de MediasoupManager,
    // no porque el backend lo registre -- verificado que 22001-22010 ya están todos ocupados
    // allá, para no reusar un número con un significado distinto.
    22011: 'No se pudo cargar el motor de videollamadas. Verifica tu conexión e intenta de nuevo.',
};
